import { API } from 'utils/api';
import { useNavigate } from 'react-router';
import { showSuccess } from 'utils/common';

const useRegister = (type = 'email') => {
  const navigate = useNavigate();
  const register = async (input, turnstile) => {
    const url = `/api/user/register${type == 'phone' ? '/phone' : ''}?turnstile=${turnstile}`;
    try {
      let affCode = localStorage.getItem('aff');
      if (affCode) {
        input = { ...input, aff_code: affCode };
      }
      const res = await API.post(url, input);
      const { success, message } = res.data;
      if (success) {
        showSuccess('注册成功！');
        navigate('/login/index');
      }
      return { success, message };
    } catch (err) {
      // 请求失败，设置错误信息
      return { success: false, message: '' };
    }
  };

  const sendVerificationCode = async (email, turnstile) => {
    try {
      const res = await API.get(`/api/verification?email=${email}&turnstile=${turnstile}`);
      const { success, message } = res.data;
      if (success) {
        showSuccess('验证码发送成功，请检查您的邮箱！');
      }
      return { success, message };
    } catch (err) {
      // 请求失败，设置错误信息
      return { success: false, message: '' };
    }
  };
  /**
   * 发送手机验证码
   * @param {*} phone 手机号
   * @returns
   */
  const sendPhoneSmsVerificationCode = async (phone, isVerify = true) => {
    try {
      const res = await API.post(`/api/user/sms`, { phone, is_verify: isVerify || undefined });
      const { success, message } = res.data;
      if (success) {
        showSuccess('验证码发送成功，请检查您的短信！');
      }
      return { success, message };
    } catch (err) {
      // 请求失败，设置错误信息
      return { success: false, message: '' };
    }
  };

  return { register, sendVerificationCode, sendPhoneSmsVerificationCode };
};

export default useRegister;
